import { motion } from 'framer-motion';

const RefundPolicy = () => {
  return (
    <motion.div 
      className="container mx-auto py-16 px-4 sm:px-6 lg:px-8 max-w-4xl text-theme-secondary"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-3xl font-bold mb-8 text-center text-primary dark:text-theme-primary">Refund Policy</h1>
      <p className="text-sm text-theme-secondary mb-8 text-center">Last updated: August 19, 2025</p>
      
      <div className="prose prose-lg dark:prose-invert max-w-none">
        <p>
          We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.
        </p>
        
        <p>
          To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, 
          and in its original packaging. You'll also need the receipt or proof of purchase.
        </p>
        
        <p>
          To start a return, you can contact us at <a href="mailto:info@konnectbetter.com" className="text-secondary hover:underline">info@konnectbetter.com</a>. 
          Please note that returns will need to be sent to the following address: <a href="https://maps.google.com/?q=2+St+Clair+Ave+E+%23800,+Toronto+ON+M4T+2T5" target="_blank" rel="noopener noreferrer" className="text-secondary hover:underline">2 St Clair Ave E #800, Toronto, ON M4T 2T5</a>
        </p>
        
        <p>
          If your return is accepted, we'll send you a return shipping label, as well as instructions on how and where to send your package. 
          Items sent back to us without first requesting a return will not be accepted.
        </p>
        
        <p>
          You can always contact us for any return questions at <a href="mailto:info@konnectbetter.com" className="text-secondary hover:underline">info@konnectbetter.com</a>.
        </p>
        
        <h2 className="text-2xl font-bold mt-8 mb-4">Damages and issues</h2>
        <p>
          Please inspect your order upon receipt and contact us immediately if the item is defective or damaged or if you receive the wrong item 
          so that we can evaluate the issue and make it right.
        </p>
        
        <h2 className="text-2xl font-bold mt-8 mb-4">Exceptions / non-returnable items</h2>
        <p>
          Certain types of items cannot be returned, like perishable goods (such as food, flowers, or plants), custom products (such as special orders 
          or personalized items), and personal care goods (such as beauty products). We also do not accept returns for hazardous materials, flammable 
          liquids, or gases. Please get in touch if you have questions or concerns about your specific item.
        </p>
        
        <p>
          Unfortunately, we cannot accept returns on sale items or gift cards.
        </p>
        
        <h2 className="text-2xl font-bold mt-8 mb-4">Exchanges</h2>
        <p>
          The fastest way to ensure you get what you want is to return the item you have, and once the return is accepted, make a separate purchase 
          for the new item.
        </p>
        
        <h2 className="text-2xl font-bold mt-8 mb-4">European Union 14-day cooling off period</h2>
        <p>
          Notwithstanding the above, if the merchandise is being shipped into the European Union, you have the right to cancel or return your order 
          within 14 days, for any reason and without a justification. As above, your item must be in the same condition that you received it, unworn 
          or unused, with tags, and in its original packaging. You'll also need the receipt or proof of purchase.
        </p>
        
        <h2 className="text-2xl font-bold mt-8 mb-4">Refunds</h2>
        <p>
          We will notify you once we've received and inspected your return, and let you know if the refund was approved or not. If approved, you'll 
          be automatically refunded on your original payment method within 10 business days. Please remember it can take some time for your bank or 
          credit card company to process and post the refund too.
        </p>
        
        <p>
          If more than 15 business days have passed since we've approved your return, please contact us at 
          <a href="mailto:info@konnectbetter.com" className="text-secondary hover:underline ml-1">info@konnectbetter.com</a>.
        </p>
      </div>
    </motion.div>
  );
};

export default RefundPolicy;
